import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  topScrollPaper: {
    alignItems: 'flex-start'
  },
  topPaperScrollBody: {
    verticalAlign: 'top'
  },
  Content: {
    height: '600px',
    maxHeight: '600px'
  },
  Video: {
    maxHeight: '300px'
  },
  FlexCol: {
    margin: 'auto',
    height: '60%',
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '48px'
  }
}));
